import React from 'react'

import Appointments from '../Appointments'

const PatientAppointments = ({patientId}) => {
    return <Appointments patientId={patientId}/>
}

export default PatientAppointments